import {
  ACTIVATE_TOTP,
  ACTIVATE_TOTP_LOGIN,
  VERIFY_CODE_TOTP,
  MFA_RESET,
  FETCH_MFA,
  DELETE_TOTP,
  RESEND_RECOVERY_CODE_EMAIL,
  VERIFY_CODE_EMAIL_PERFIL,
  VERIFY_CODE_EMAIL_LOGIN,
  VERIFY_CODE_EMAIL_LOGIN_UUID,
  VERIFY_CODE_TOTP_LOGIN,
} from 'constants/ActionTypes';

const INITIAL_STATE = {
  estado: {},
  methods: {},
  errors: null,
  loading: false,
};
// eslint-disable-next-line default-param-last
export default function mfaReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ACTIVATE_TOTP.SUCCESS: {
      return {
        ...state,
        methods: { ...state.methods, totp: action.payload.data },
        errors: null,
        loading: false,
      };
    }
    case ACTIVATE_TOTP.ERROR:
      return {
        ...state,
        errors: action.payload.error,
        loading: false,
      };
    case ACTIVATE_TOTP.PENDING:
      return {
        ...state,
        loading: true,
      };

    case ACTIVATE_TOTP_LOGIN.SUCCESS: {
      return {
        ...state,
        methods: { ...state.methods, totp: action.payload.data },
        errors: null,
        loading: false,
      };
    }
    case ACTIVATE_TOTP_LOGIN.ERROR:
      return {
        ...state,
        errors: action.payload.error,
        loading: false,
      };
    case ACTIVATE_TOTP_LOGIN.PENDING:
      return {
        ...state,
        loading: true,
      };

    case VERIFY_CODE_TOTP.SUCCESS: {
      return {
        ...state,
        errors: null,
        loading: false,
      };
    }
    case VERIFY_CODE_TOTP.ERROR:
      return {
        ...state,
        errors: action.payload.error,
        loading: false,
      };
    case VERIFY_CODE_TOTP.PENDING:
      return {
        ...state,
        loading: true,
      };
    case VERIFY_CODE_TOTP_LOGIN.SUCCESS: {
      return {
        ...state,
        errors: null,
        loading: false,
      };
    }
    case VERIFY_CODE_TOTP_LOGIN.ERROR:
      return {
        ...state,
        errors: action.payload.error,
        loading: false,
      };
    case VERIFY_CODE_TOTP_LOGIN.PENDING:
      return {
        ...state,
        loading: true,
      };
    case FETCH_MFA.SUCCESS: {
      return {
        ...state,
        estado: action.payload.data.estado,
        methods: action.payload.data.methods,
        estado_email: action.payload.data.estado_email,
        loading: false,
      };
    }
    case FETCH_MFA.ERROR:
      return {
        ...state,
        errors: action.payload.error,
        loading: false,
      };
    case FETCH_MFA.PENDING:
      return {
        ...state,
        loading: true,
      };

    case DELETE_TOTP.SUCCESS: {
      return {
        ...state,
        estado: { ...state.estado, activado: false, fecha_activado: null },
        methods: {},
        loading: false,
      };
    }
    case DELETE_TOTP.ERROR:
      return {
        ...state,
        errors: action.payload.error,
        loading: false,
      };
    case DELETE_TOTP.PENDING:
      return {
        ...state,
        loading: true,
      };

    case MFA_RESET:
      return {
        ...state,
        errors: null,
      };

    case RESEND_RECOVERY_CODE_EMAIL.SUCCESS: {
      return {
        ...state,
        loading: false,
      };
    }
    case RESEND_RECOVERY_CODE_EMAIL.ERROR:
      return {
        ...state,
        loading: false,
      };
    case RESEND_RECOVERY_CODE_EMAIL.PENDING:
      return {
        ...state,
        loading: true,
      };
    case VERIFY_CODE_EMAIL_PERFIL.SUCCESS: {
      return {
        ...state,
        errors: null,
        loading: false,
      };
    }
    case VERIFY_CODE_EMAIL_PERFIL.ERROR:
      return {
        ...state,
        errors: action.payload.error,
        loading: false,
      };
    case VERIFY_CODE_EMAIL_PERFIL.PENDING:
      return {
        ...state,
        loading: true,
      };
    case VERIFY_CODE_EMAIL_LOGIN.SUCCESS: {
      return {
        ...state,
        errors: null,
        loading: false,
      };
    }
    case VERIFY_CODE_EMAIL_LOGIN.ERROR:
      return {
        ...state,
        errors: action.payload.error,
        loading: false,
      };
    case VERIFY_CODE_EMAIL_LOGIN.PENDING:
      return {
        ...state,
        loading: true,
      };
    case VERIFY_CODE_EMAIL_LOGIN_UUID.SUCCESS: {
      return {
        ...state,
        errors: null,
        loading: false,
      };
    }
    case VERIFY_CODE_EMAIL_LOGIN_UUID.ERROR:
      return {
        ...state,
        errors: action.payload.error,
        loading: false,
      };
    case VERIFY_CODE_EMAIL_LOGIN_UUID.PENDING:
      return {
        ...state,
        loading: true,
      };

    // DEFAULT
    default:
      return state;
  }
}
